/* eslint-disable import/prefer-default-export */
import styled from 'styled-components'
// @ts-ignore
import { sys } from '@netbasequid/theme'

export const StyledSemiboldText = styled.span`
  font-weight: ${sys.fontWeight.semibold};
`
